import React from "react";
import Logo from "../../assets/logos/rl/reversinglabs-logo.svg";
const ReversingLabsLogo = ({ className, }) => {
    return React.createElement(Logo, { className: className });
};
export default ReversingLabsLogo;
//# sourceMappingURL=ReversingLabsLogo.js.map